import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "container",
    class: "virtual-grid",
    style: _normalizeStyle(_ctx.containerStyle),
    onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
  }, [
    _createElementVNode("div", {
      class: "spacer",
      style: _normalizeStyle({ height: _ctx.totalHeight + 'px' })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleItems, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: _ctx.itemKey(item),
          class: "cell",
          style: _normalizeStyle(_ctx.cellStyle(_ctx.startIndex + i))
        }, [
          _renderSlot(_ctx.$slots, "default", {
            item: item,
            index: _ctx.startIndex + i
          }, undefined, true)
        ], 4))
      }), 128))
    ], 4)
  ], 36))
}